import React, {useState} from 'react';
import RequestStatus from "../../components/RequestStatus/RequestStatus";
import iconAvatar from "url:shared-assets/icons/ai.svg";

const Testing = () => {

  const [status, setStatus] = useState("pending_self");
  const [lang, setLang] = useState("sv");
  const [multiple, setMultiple] = useState(false);
  const [partial, setPartial] = useState(false);
  const statuses = [
    ["pending_self", "Self-assessment not completed"],
    ["invite_other", "Not invited feedback recipients"],
    ["pending_other", "Waiting for feedback"],
    ["failed_resend", "Request failed, try again"],
    ["failed_old", "Request failed > 3 months after deadline, create new request"],
    ["completed", "Completed"]
  ];

  const renderStatus = () => {
    return <RequestStatus status={status} language={lang} multipleRequest={multiple} surveyRequestId="0"
                          deadline="2026-09-01" partial={partial}/>;
  }


  return (
    <div className="main-one-col small">
      <div className="text-xl mt-4">Test Request status</div>
      <img src={iconAvatar} className="h-6 w-6" alt="ai" />

      <div className="mt-4">
        <select className="z-select" value={status}
                onChange={(e) => setStatus(e.target.value)}>
          {
            statuses.map(_status => (
              <option key={"s_" + _status[0]} value={_status[0]}>{_status[1]}</option>
            ))
          }
        </select>
      </div>


      <div className="flex gap-x-4 mt-2">
        <div className={lang === "sv" ? "font-medium" : "underline cursor-pointer"} onClick={() => setLang('sv')}>Swedish</div>
        <div className={lang === "en" ? "font-medium" : "underline cursor-pointer"} onClick={() => setLang('en')}>English</div>
      </div>

      <div className="flex gap-x-4 mt-2">
        <div className={!partial ? "font-medium" : "underline cursor-pointer"} onClick={() => setPartial(false)}>Full survey</div>
        <div className={partial ? "font-medium" : "underline cursor-pointer"} onClick={() => setPartial(true)}>Goal survey</div>
      </div>

      <div className="flex gap-x-4 mt-2">
        <div className={!multiple ? "font-medium" : "underline cursor-pointer"} onClick={() => setMultiple(false)}>Normal survey</div>
        <div className={multiple ? "font-medium" : "underline cursor-pointer"} onClick={() => setMultiple(true)}>Automatic survey</div>
      </div>

      <div className="mt-8">
        {renderStatus()}
      </div>

    </div>

  )
};

export default Testing;